import React, {Component} from "react";
import CreateDialog from "../../common/CreateDialog/CreateDialog";

class AccountContact extends Component {


    constructor(props, context) {
        super(props, context);
        this.state = {
            contact: this.props.contact,
            invalidFields: {
                firstName: {
                    invalid: false,
                    message: ""
                },
                lastName: {
                    invalid: false,
                    message: ""
                },
                email: {
                    invalid: false,
                    message: ""
                }
            }
        }
    }

    validName = (e, name_field) => {
        const newName = e.target.value.trim();
        let isNameInvalid = this.state.invalidFields[name_field].invalid;
        if (newName === "") {
            isNameInvalid = true;
        } else {
            isNameInvalid = false;
        }
        let localContact = {...this.state.contact}
        localContact[name_field] = newName;

        this.setState({
            invalidFields: {
                ...this.state.invalidFields,
                [name_field]: {
                    invalid: isNameInvalid,
                    message: isNameInvalid ? "Required field" : ""
                }
            },
            contact: localContact
        });
    };

    checkValue = (input, field) => {
        if (!input[field] || input[field] === "") input[field] = this.props.contact[field]
    }

    saveContact = () => {
        let contactInfo = {...this.state.contact}
        if (this.props.contact) {
            this.checkValue(contactInfo, "firstName")
            this.checkValue(contactInfo, "lastName")
            this.checkValue(contactInfo, "email")
        }
        this.props.editHandler(contactInfo)
    }

    render() {
        let defaultContact = {
            firstName: this.props.contact ? this.props.contact.firstName : "",
            lastName: this.props.contact ? this.props.contact.lastName : "",
            email: this.props.contact ? this.props.contact.email : ""
        }
        return (
            <div>
                <CreateDialog
                    isModalVisible={this.props.isVisible}
                    handleDialogToggle={this.props.hideHandler}
                    action={this.saveContact}
                    modalHeaderName="Edit Contact"
                    modalBodyFields={[
                        {
                            label: "First Name",
                            id: "contact_firstName",
                            inputType: "text",
                            onChange: this.validName,
                            validateFieldName: "firstName",
                            newField: this.state.contact.firstName,
                            defaultValue: defaultContact.firstName
                        },
                        {
                            label: "Last Name",
                            id: "contact_lastName",
                            inputType: "text",
                            onChange: this.validName,
                            validateFieldName: "lastName",
                            newField: this.state.contact.lastName,
                            defaultValue: defaultContact.lastName
                        },
                        {
                            label: "Email",
                            id: "contact_email",
                            inputType: "text",
                            onChange: this.validName,
                            validateFieldName: "email",
                            newField: this.state.contact.email,
                            defaultValue: defaultContact.email
                        }
                    ]}
                />
            </div>
        )
    }
}

export default AccountContact;


// WEBPACK FOOTER //
// ./src/accounts/components/AccountContact.js